import axios from 'axios';

export const REST_API = 'https://sp.demoapi.v2.hyperthings.in/api/v1/';
// export const REST_API = 'https://iot.hyperthink.io:7006/api/v1/';

// axios implementation
const token = localStorage.getItem('token');
export const fetcher = axios.create({
  baseURL: REST_API,
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    Authorization: `Bearer ${token}`,
  },
});

export const sendRequest = (url, method, body) =>
  fetcher({
    method,
    url,
    data: body,
  }).then((res) => res.data);
